import { useReducer, useCallback } from 'react'

const cPopupInitialState = {
    visible: false,
    title: '',
    desc: '',
    confirmCb: undefined as Function | undefined,
    rejectCb: undefined as Function | undefined,
}
const cPopupReducer = (state: any, action: any) => {
    switch (action.type) {
        case 'show':
            return { ...state, ...action.payload, visible: true }
        case 'close':
            return cPopupInitialState
    }
}

export const useIxConfirmPopupReducer = () => {
    const [cPopup, cPopupDispatch] = useReducer(cPopupReducer, cPopupInitialState)

    const showConfirmPopup = useCallback((payload: typeof cPopupInitialState) => {

        const confirmCbWrapper = async () => {
            await (payload.confirmCb && payload.confirmCb())
            cPopupDispatch({ type: 'close' })
        }

        const rejectCbWrapper = async () => {
            await (payload.rejectCb && payload.rejectCb())
            cPopupDispatch({ type: 'close' })
        }

        cPopupDispatch({
            type: 'show',
            payload: {
                ...payload,
                confirmCb: confirmCbWrapper,
                rejectCb: rejectCbWrapper,
            }
        })
    }, [cPopupDispatch])

    return [ cPopup, showConfirmPopup ]
}
